// services/auditService.js
import api from './api'; // or your configured axios instance

export const getProjectAuditLogs = async (projectId, {
  page = 0,
  size = 20,
  subjects = '', // CSV string: "Form,FormGroup,Field"
  from,
  to,
  username,
  subjectId,
  action,
  orderBy = 'createdAt',
  orderDir = 'DESC',
}) => {
  const params = {
    page,
    size,
    subjects,
    from,
    to,
    username,
    subjectId,
    action,
    orderBy,
    orderDir,
  };

  const { data } = await api.get(`/projects/${projectId}/audit-logs`, { params });
  return data;
};
